const CustomAlarmMode = {
  STATIC: 'static',
  COMPARISON: 'comparison',
};

export default CustomAlarmMode;
